const NightChanges = [
	'[Verse 1]',
	'Going out tonight, changes into something red',
	"Her mother doesn't like that kind of dress",
	'Everything she never had',
	'She’s showing off',
	'Driving too fast, moon is breaking through her hair',
	"She's heading for something that she won’t forget",
	'Having no regrets is all that she really wants',
	'',
	'[Chorus]',
	"We're only getting older baby",
	"And I've been thinking about it lately",
	'Does it ever drive you crazy',
	'Just how fast the night changes',
	"Everything that you've ever dreamed of",
	'Disappearing when you wake up',
	'But there’s nothing to be afraid of',
	'Even when the night changes',
	'It will never change me and you',
	'',
	'[Verse 2]',
	'Chasing her tonight, doubts are running ‘round her head',
	'He’s waiting, hides behind his cigarette',
	"Heart is beating loud, she doesn't want it to stop",
	'Moving too fast, moon is lighting up her skin',
	"She’s falling, doesn't even know it yet",
	'Having no regrets is all that she really wants',
	'',
	'[Chorus]',
	"We're only getting older baby",
	"And I've been thinking about it lately",
	'Does it ever drive you crazy',
	'Just how fast the night changes',
	"Everything that you've ever dreamed of",
	'Disappearing when you wake up',
	'But there’s nothing to be afraid of',
	'Even when the night changes',
	'It will never change me and you',
	'',
	'[Bridge]',
	'Going out tonight, changes into something red',
	"Her mother doesn't like that kind of dress",
	'Reminds her of a missing piece of innocence she lost',
	'',
	'[Final Chorus]',
	"We're only getting older baby",
	"And I've been thinking about it lately",
	'Does it ever drive you crazy',
	'Just how fast the night changes',
	"Everything that you've ever dreamed of",
	'Disappearing when you wake up',
	'But there’s nothing to be afraid of',
	'Even when the night changes',
	"Everything that you've ever dreamed of",
	'Disappearing when you wake up',
	'But there’s nothing to be afraid of',
	'Even when the night changes',
	'',
	'[Outro]',
	'It will never change, baby',
	'We will never change, baby',
	'It will never change me and you',
];

export default NightChanges;
